import qs from "qs";
import BaseApiService from "./BaseApiService";
import trackingService from "./trackingService"; // Import your existing tracking service


const messageHandlerApiPath = process.env.REACT_APP_MESSAGE_HANDLER_URL;

const _sendMessage = (
  phone,
  payload,
  code = process.env.REACT_APP_ON_MESSAGE_API_CODE
) => {
  // Get tracking headers from your tracking service
  const trackingHeaders = trackingService.getTrackingHeaders();
  // const encodedPayload = qs.stringify(payload);

   const headers = {
    "Content-Type": "application/json",
    ...trackingHeaders
  };

  return BaseApiService.request(
    "POST",
    `${messageHandlerApiPath}/api/v1/${phone}/messages`,
    null,
    payload,
    false,
    {},
    // { "Content-Type": "application/x-www-form-urlencoded" },
    headers,
    false,
    true
  );
};

const _broadcastMessage = (
  payload,
  code = process.env.REACT_APP_ON_MESSAGE_API_CODE
) => {
  const trackingHeaders = trackingService.getTrackingHeaders();
  const encodedPayload = qs.stringify(payload);
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    ...trackingHeaders
  };

  return BaseApiService.post(
    `${messageHandlerApiPath}/api/v1/broadcast?code=${code}`,
    null,
    encodedPayload,
    false,
    {},
    headers
  );
};

const downloadAnalyzedConversation = (
  code = process.env.REACT_APP_ON_MESSAGE_API_CODE
) => {
  return BaseApiService.get(
    `/api/v1/assistant/conversations/download?code=${code}`,
    {},
    true,
    {
      responseType: "blob",
      headers: { Accept: "application/zip" },
    }
  );
};

const getImageURL =(payload,code = process.env.REACT_APP_ON_MESSAGE_API_CODE)=>{
  return BaseApiService.post(`/api/v1/journal/getmediaurl?code=${code}`,null,payload);
}

const createJournal =(payload,code = process.env.REACT_APP_ON_MESSAGE_API_CODE)=>{
  return BaseApiService.post(`/api/v1/journal/create?code=${code}`,null,payload);
}

const system_warm_up=()=>{
  return BaseApiService.request(
    "GET",
    `${messageHandlerApiPath}/api/v1/health`,
    null,
    null,
    false,
    {},
    {"Content-Type": "application/json"},
    false,
    true
  );
}

export const MessageAPIService = {
  sendMessage: _sendMessage,
  broadcastMessage: _broadcastMessage,
  downloadAnalyzedConversation,
  getImageURL,
  createJournal,
  system_warm_up
};
